<template>
  <div class="freeboard-ads-media__item">
    <div class="input-wrap">
      <input type="text" name="" v-model="data.url" placeholder="Image link">
    </div>

    <div class="freeboard-ads-media-inner">
      <div
        class="freeboard-media-has-image"
        v-if="adsData.image"
        :style="`background-image: url(${adsData.image})`"
      >
      </div>

      <div class="freeboard-media-no-image" v-if="!adsData.image">
        <i class="ico--no-image"></i>
        <span class="freeboard-media-label">
          No Image<br/>
          available
        </span>
      </div>

      <div class="freeboard-media-hover">
        <div class="freeboard-media-hover-inner">
          <label for="file-ads-0" class="freeboard-ads-fileinput">
            <i class="ico--upload"></i>
            <input
              type="file"
              @change="attachImage"
              ref="data-image"
            >
          </label>

          <button
            class="btn--delete"
            @click="$emit('del', data.id)"
          >
            <i class="ico--delete"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import { mapState, mapActions } from 'vuex'
export default {
  name: 'ad-items',

  props: {
    data: [Object],
    saved: [Boolean]
  },

  created () {
    this.image = null
  },

  computed: {
    adsData () {
      if (this.data.image && this.data.image.indexOf(this.imgPath) <= -1) {
        this.data.image = `${this.imgPath}${this.data.image}`
      }

      if (this.image) {
        this.data.image = this.image
      }

      return this.data
    }
  },

  data () {
    return {
      image: null,
      imgPath: process.env.VUE_APP_STATIC_ASSET_PATH,
      url: ''
    }
  },

  methods: {
    ...mapActions('freeBoard', ['deleteAdvertisement', 'getAdvertisement']),

    attachImage (e) {
      if (e.target.files && e.target.files.length !== 0) {
        let fileReader = new FileReader()

        fileReader.onload = (event) => {
          this.image = event.target.result
          this.$nextTick(() => {
            this.$refs['data-image'].files = e.target.files
          })
        }

        this.data.files = e.target.files
        fileReader.readAsDataURL(e.target.files[0])
      }
    }
  }
}
</script>
